import { ZOOM_LEVELS } from '../../../../../constants/Map'


export const getZoomLevels = (zoom: number) => {
  return {
    isStateZoom: zoom >= ZOOM_LEVELS.STATE.MIN && zoom < ZOOM_LEVELS.STATE.MAX,
    isCountyZoom: zoom >= ZOOM_LEVELS.COUNTY.MIN
  }
}